import { OctopusRoutingProvider, DesignSystemLinkHref } from "@octopusdeploy/design-system-components";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import PortalLink from "./PortalLink";

class PortalOctopusRoutingProvider extends React.PureComponent<React.PropsWithChildren<RouteComponentProps>> {
    render() {
        // TODO: implement link analytics tracking - useDispatchLinkAnalytics was added as a required prop in design-system 2026.2.4991
        return (
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            <OctopusRoutingProvider Link={PortalLink} useIsUrlActive={() => this.useIsUrlActive} useDispatchLinkAnalytics={() => () => {}}>
                {this.props.children}
            </OctopusRoutingProvider>
        )
    }

    private useIsUrlActive = (path: DesignSystemLinkHref, exact: boolean | undefined) => {
        if (typeof(path) !== "string") {
            // Server uses a path object to handle new vs old routing; should never occur in CloudPortal. 
            return false;
        }
        const currentUrl = this.props.location.pathname;
        if (exact) {
            return currentUrl === path;
        }
        const pathWithoutQueryString = path.split("?", 2)[0];
        return currentUrl.startsWith(pathWithoutQueryString);
    }
}

export default withRouter(PortalOctopusRoutingProvider);
